import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-table-input",
  templateUrl: "./table-input.component.html",
  styleUrls: ["./table-input.component.scss"],
})
export class TableInputComponent implements OnChanges {
  @Input() bindedValue: string = "";
  @Input() isInputDisabled: boolean = false;
  @Output() actionBtnCallback = new EventEmitter<any>();

  selectedValue: string = "";

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      const value = changes?.bindedValue?.currentValue;
      this.selectedValue = value || "";
    }
  }

  onBlur() {
    this.actionBtnCallback.emit(this.selectedValue);
  }
}
